<router-outlet />
<auth-recovery-panel />
<p-toast />
